import { render, staticRenderFns } from "./UserVisitSector.vue?vue&type=template&id=42950733&"
import script from "./UserVisitSector.vue?vue&type=script&lang=js&"
export * from "./UserVisitSector.vue?vue&type=script&lang=js&"
import style0 from "./UserVisitSector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports